import React, { useRef, useState, useMemo, useLayoutEffect } from 'react'
import { createPortal } from 'react-dom'
import classnames from 'classnames'
import { IconButton, ICON_TYPES } from '@st-operations/uikit/src/v2'

import './styles.scss'

const Container = ({ children, className, startOpen }) => {
  const portalRef = useRef(null)

  useLayoutEffect(() => {
    portalRef.current = document.getElementById('optionsPanel')
  }, [])
  const [isOpen, setIsOpen] = useState(startOpen)

  const handleToggleSidebar = () => {
    setIsOpen((prev) => !prev)
  }

  const iconButtonClasses = useMemo(
    () => ({
      icon: classnames('side-panel__collapse-icon', {
        'side-panel__collapse-icon--open': isOpen,
      }),
      button: 'side-panel__collapse-button',
    }),
    [isOpen]
  )

  const ToggleButton = useMemo(
    () => (
      <IconButton
        key="side-panel-open-button"
        iconProps={{
          icon: 'angledown',
          type: ICON_TYPES[0],
          width: '24px',
          height: '24px',
        }}
        classes={iconButtonClasses}
        onClick={handleToggleSidebar}
        ariaLabel={`${isOpen ? 'hide' : 'show'} regions`}
      />
    ),
    [handleToggleSidebar, iconButtonClasses]
  )

  return (
    <div
      key="side-panel-container"
      className={classnames('side-panel', { 'side-panel--open': isOpen }, className)}
    >
      {children}
      {portalRef.current && createPortal(ToggleButton, portalRef.current)}
    </div>
  )
}

const useSidePanel = () => {
  const portalRef = useRef(null)

  useLayoutEffect(() => {
    portalRef.current = document.getElementById('optionsPanel')
  }, [])

  return { containerRef: portalRef.current, Container }
}

export default useSidePanel
